<template>
  <div>
    <section v-for="(slice, index) in slices" :key="'slice-' + index">
      <template v-if="slice.slice_type === 'call_to_action'">
        <call-to-action :slice="slice"/>
      </template>
      <template v-else>
        <div class="container">
          <template v-if="slice.slice_type === 'jumbotron'">
            <jumbotron :slice="slice" :uid="uid"/>
          </template>
          <template v-if="slice.slice_type === 'hero'">
            <hero :slice="slice" :uid="uid" :index="index"/>
          </template>
          <template v-else-if="slice.slice_type === 'text'">
            <text-slice :slice="slice"/>
          </template>
          <template v-else-if="slice.slice_type === 'icon_row'">
            <icon-row :slice="slice"/>
          </template>
        </div>
      </template>
    </section>
  </div>
</template>

<script>
// Imports for all slices
import Jumbotron from "@/components/slices/Jumbotron.vue";
import Hero from "@/components/slices/Hero.vue";
import TextSlice from "@/components/slices/TextSlice.vue";
import IconRow from "@/components/slices/IconRow.vue";
import CallToAction from "@/components/slices/CallToAction.vue";

export default {
  props: ['slices', 'uid'],
  name: 'slices-block',
  components: {
    Jumbotron,
    Hero,
    TextSlice,
    IconRow,
    CallToAction
  }
}
</script>